import React, { useState } from "react";
import Button from "./Button";
// import { set } from "lodash";

type Props = {
  type: string;
  name?: string;
  autoComplete?: "on" | "off";
  indicatorStyle?: string;
  placeholder?: string;
  style?: string;
  inputStyle?: string;
  inputStyle2?: string;
  inputContainerStyle?: string;
  label?: string;
  labelStyle?: string;
  value?: string;
  img?: string;
  imgStyle?: string;
  imgOnClick?: (e?: any) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  required?: boolean;
  btnElement?: boolean;
  btnType?: "button" | "submit" | "reset" | undefined;
  btnText?: string;
  btnImg?: any;
  btnImgStyle?: string;
  btnStyle?: string;
  validationErr?: any;
  onClick?: () => void;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const FormInput = React.forwardRef(
  (
    {
      label,
      labelStyle,
      indicatorStyle,
      autoComplete,
      type,
      name,
      placeholder,
      style,
      inputStyle,
      inputStyle2,
      inputContainerStyle,
      value,
      required,
      img,
      imgStyle,
      imgOnClick,
      min,
      max,
      validationErr,
      disabled,
      onChange,
      btnElement,
      btnType,
      btnText,
      btnImg,
      btnImgStyle,
      btnStyle,
      onClick,
    }: Props,
    ref
  ) => {

    const btnContent = (
      <Button
        btnType={btnType}
        btnText={btnText}
        btnImg={btnImg}
        btnImgStyle={btnImgStyle}
        btnStyle={btnStyle}
        onClick={onClick}
      />
    );

    // const [showError, setShowError] = useState(false)

    // if(validationErr !== ''){
    //     set
    // }

    return (
      <div className={`a ${style} flex flex-col`}>
        {label && (
          <label className={`${labelStyle} mb-2 flex gap-1`} htmlFor={name}>
            {label}
            {required && (
              <span style={{ color: "rgb(255 34 0)" }} className="font-16">
                *
              </span>
            )}
          </label>
        )}
        {btnElement && img ? (
          <div className={`${inputContainerStyle} flex`}>
            <span
              className={`${inputStyle} bg-white flex items-center w-3/4 rounded-md overflow-hidden relative`}
            >
              <img
                src={img}
                alt="icon"
                className={`${imgStyle} absolute right-5`}
                onClick={imgOnClick}
              />
              <input
                type={type}
                id={name}
                name={name}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                min={min}
                max={min}
                required={required}
                className={`${inputStyle2} py-2 bg-NoColor outline-none w-full`}
                disabled={disabled}
                autoComplete={autoComplete}
              />
            </span>
            {btnContent}
          </div>
        ) : btnElement && !img ? (
          <div className={`${inputContainerStyle} flex`}>
            <span
              className={`${inputStyle} bg-white rounded-md overflow-hidden w-3/4`}
            >
              <input
                type={type}
                name={name}
                id={name}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                min={min}
                max={min}
                required={required}
                className={`${inputStyle2} w-full bg-NoColor outline-none py-2 px-2`}
                disabled={disabled}
                autoComplete={autoComplete}
              />
            </span>
            {btnContent}
          </div>
        ) : !btnElement && img ? (
          <span
            className={`d-span flex ${inputStyle} bg-white items-center rounded-md overflow-hidden relative`}
          >
            <img
              src={img}
              alt="icon"
              className={`${imgStyle} absolute right-5`}
              onClick={imgOnClick}
            />
            <input
              type={type}
              name={name}
              id={name}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              min={min}
              max={min}
              required={required}
              className={`${inputStyle2} w-full bg-NoColor outline-none py-2 px-2`}
              disabled={disabled}
              autoComplete={autoComplete}
            />
          </span>
        ) : (
          <span
            className={`e-span ${inputStyle} bg-white rounded-md overflow-hidden`}
          >
            <input
              type={type}
              name={name}
              id={name}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              min={min}
              max={min}
              required={required}
              className={`${inputStyle2} w-full bg-NoColor outline-none py-2 px-2`}
              disabled={disabled}
              autoComplete={autoComplete}
            />
          </span>
        )}
        <div
          className={`${indicatorStyle} border border-NoColor w-full rounded-full p-[1px] mt-1`}
        ></div>
        {validationErr && (
          <div className="mt-2 text-right f-span">
            <span className="text-xs font-medium text-red-500">
              {validationErr}
            </span>
          </div>
        )}
      </div>
    );
  }
);

export default FormInput;


//added id and for attributes to the form input and label